import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

const tableRowFormatter: NodeSerializerSpec = async (state, node) => {
	state.write(`---\n\n`);
	// Loose on purpose. In the `{% table %}` syntax a cell is a list item, and the blank line between
	// items is what separates one cell from the next -- not spacing the standard format could drop.
	await state.renderList(
		node,
		() => "   ",
		() => `${node.attrs.bullet || "*"}  `,
		false,
	);
};

export default tableRowFormatter;
